enum PlaylistStateEnum {
    VeryClosed,
    Closed,
    Open
}

export default PlaylistStateEnum;
